/**
 * Chekly Buy-Now Extension — omriyana.shop
 *
 * MUST be loaded BEFORE chekly-script.js in theme.liquid!
 *
 * Problem: The "Купити зараз" button is an anchor link:
 *   <a href="/cart/{variantId}:{qty}?checkout" class="custom-checkout-btn">
 *
 * Chekly matches it via [class*="checkout-btn"] and calls processCheckout()
 * with no args (cartToken path, empty cart → redirect back).
 * If it already has chekly-procceded="true" in server HTML, Chekly skips it
 * entirely and the browser just follows the href to Shopify checkout.
 *
 * Fix: intercept pointerdown (fires before mousedown/Chekly handlers),
 * extract variantId + quantity from the href pattern /cart/{id}:{qty}?checkout,
 * and redirect to Chekly with variantID= instead.
 *
 * Also handles /en/cart/... subfolder variant.
 */
(function () {
  'use strict';

  var TAG = '[chekly-omriyana-ext]';
  console.log(TAG, 'loaded');

  // href format: /cart/{variantId}:{quantity}?checkout
  //           or /en/cart/{variantId}:{quantity}?checkout
  var CART_CHECKOUT_RE = /\/cart\/(\d+):(\d+)\?checkout/;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function getCookie(name) {
    var re = new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
    var m = document.cookie.match(re);
    return m ? decodeURIComponent(m[1]) : undefined;
  }

  function buildCheklyUrl(variantId, quantity) {
    var el = document.querySelector('[data-chekly-url]');
    if (!el) return null;

    var appUrl = el.getAttribute('data-checkout-domain') || el.getAttribute('data-chekly-url') || '';
    if (!appUrl) return null;

    var theme = el.getAttribute('data-chekly-theme') || '';
    var originHost = window.location.host;
    var shopDomain = (window.Shopify && window.Shopify.shop) || '';
    var curRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    var countryCode = (window.Shopify && window.Shopify.country) || 'UA';
    var customer = window.Shopify && window.Shopify.customer;

    var url = appUrl + '/checkout/?storeName=' + originHost
      + '&variantID=' + variantId
      + '&customerCountryCode=' + countryCode
      + '&variantQuantity=' + (quantity || '1')
      + '&curRate=' + curRate
      + (theme ? '&theme=' + theme : '')
      + '&shopifyDomain=' + shopDomain
      + (root.length > 2 ? '&subFolder=' + root.replace(/\//g, '') : '');

    if (customer) {
      if (customer.firstName) url += '&user_name='     + encodeURIComponent(customer.firstName);
      if (customer.lastName)  url += '&user_lastname=' + encodeURIComponent(customer.lastName);
      if (customer.email)     url += '&user_email='    + encodeURIComponent(customer.email);
      if (customer.phone)     url += '&user_phone='    + encodeURIComponent(customer.phone);
    }

    var trackingData = {};
    try { trackingData = JSON.parse(getCookie('chekly_tracking') || '{}'); } catch (ex) {}
    var urlParams;
    try { urlParams = new URLSearchParams(window.location.search); }
    catch (ex) { urlParams = { get: function () { return null; } }; }

    var tracking = [
      ['utm_campaign', 'utm_campaign'], ['utm_medium',  'utm_medium'],
      ['utm_source',   'utm_source'],   ['utm_content', 'utm_content'],
      ['utm_term',     'utm_term'],     ['utm_id',      'utm_id'],
      ['fbclid',       'fbclid'],       ['ttclid',      'ttclid'],
      ['epik',         'epik'],         ['ScCid',       'sccid'],
      ['gclid',        'gclid'],
    ];
    var parts = [];
    for (var i = 0; i < tracking.length; i++) {
      var v = urlParams.get(tracking[i][0]) || trackingData[tracking[i][0]] || '';
      if (v) parts.push(tracking[i][1] + '=' + encodeURIComponent(v));
    }

    var fbc  = getCookie('_fbc'),  fbp  = getCookie('_fbp'),
        ttp  = getCookie('_ttp'),  sa_p = getCookie('_shopify_sa_p');
    var lang = (navigator.languages && navigator.languages[0] && navigator.languages[0].slice(0, 2)) || '';

    if (fbc)  parts.push('_fbc='          + encodeURIComponent(fbc));
    if (fbp)  parts.push('_fbp='          + encodeURIComponent(fbp));
    if (ttp)  parts.push('ttp='           + encodeURIComponent(ttp));
    if (sa_p) parts.push('_shopify_sa_p=' + encodeURIComponent(sa_p));
    if (lang) parts.push('utm_lang='      + lang);

    try {
      var gl = urlParams.get('_gl');
      if (gl) parts.push('_gl=' + encodeURIComponent(gl));
    } catch (ex) {}

    if (parts.length) url += '&' + parts.join('&');
    return url;
  }

  var _redirecting = false;

  function doRedirect(variantId, quantity) {
    try {
      sessionStorage.setItem('chekly_redirecting',       'true');
      sessionStorage.setItem('chekly_about_to_redirect', 'true');
      sessionStorage.setItem('chekly_redirect_timestamp', String(Date.now()));
    } catch (ex) {}

    var url = buildCheklyUrl(variantId, quantity);
    if (!url) {
      console.warn(TAG, 'buildCheklyUrl returned null — falling back to /checkout');
      window.location.href = '/checkout';
      return;
    }
    console.log(TAG, 'redirecting →', url);
    window.location.href = url;
  }

  // ── Shared buy-now detection logic ────────────────────────────────────────

  function getVariantId(link) {
    var href = link.getAttribute('href') || '';

    // 1. URL ?variant= — updated synchronously by theme JS when user picks a variant
    var currentUrlParams = new URLSearchParams(window.location.search);
    var variantId = currentUrlParams.get('variant') || null;

    // 2. form input[name="id"] — updated by theme JS
    var form = link.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!variantId) {
      var variantIdInput = form && form.querySelector('input[name="id"]');
      variantId = variantIdInput ? variantIdInput.value : null;
    }

    // 3. checked radio data-variant-id — synchronous when radio is clicked
    if (!variantId) {
      var checkedRadio = document.querySelector('input[type="radio"][data-variant-id]:checked');
      variantId = checkedRadio ? checkedRadio.getAttribute('data-variant-id') : null;
    }

    // 4. href parse — stale from initial page render (last resort)
    if (!variantId) {
      var hrefMatch = href.match(CART_CHECKOUT_RE);
      variantId = hrefMatch ? hrefMatch[1] : null;
    }

    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var quantity = (qtyInput && qtyInput.value) || '1';
    return { variantId: variantId, quantity: quantity };
  }

  function interceptBuyNow(e, target) {
    if (_redirecting) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    }
    if (!target || !target.closest) return;
    var link = target.closest('a[href*="?checkout"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (!CART_CHECKOUT_RE.test(href)) return;

    var result = getVariantId(link);
    if (!result.variantId) return;

    console.log(TAG, 'buy-now intercepted | event:', e.type, '| variantId:', result.variantId, '| qty:', result.quantity);
    _redirecting = true;
    e.stopImmediatePropagation();
    e.preventDefault();
    doRedirect(result.variantId, result.quantity);
  }

  // ── Desktop: pointerdown ───────────────────────────────────────────────────
  window.addEventListener('pointerdown', function (e) {
    interceptBuyNow(e, e.target);
  }, true);

  // ── Mobile: touchstart with passive:false ──────────────────────────────────
  // On iOS Safari 16+ and Chrome Android, touchstart listeners added to window
  // are PASSIVE by default — preventDefault() is silently ignored, so the link
  // still navigates. We must explicitly opt out of passive mode.
  // touchstart fires in the same event sequence as pointerdown (after it on most
  // browsers), so _redirecting is already true if pointerdown already fired —
  // this still blocks the synthesised click that follows touchend.
  try {
    window.addEventListener('touchstart', function (e) {
      var touch = e.touches && e.touches[0];
      var target = touch
        ? document.elementFromPoint(touch.clientX, touch.clientY)
        : e.target;
      interceptBuyNow(e, target);
    }, { capture: true, passive: false });
  } catch (ex) {
    // Fallback for very old browsers that don't support options object
    window.addEventListener('touchstart', function (e) {
      var touch = e.touches && e.touches[0];
      var target = touch
        ? document.elementFromPoint(touch.clientX, touch.clientY)
        : e.target;
      interceptBuyNow(e, target);
    }, true);
  }

  // Block click as final safety net (covers Chekly handlers that might run after us)
  window.addEventListener('click', function (e) {
    if (!_redirecting) return;
    var link = e.target && e.target.closest && e.target.closest('a[href*="?checkout"]');
    if (link) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);

  // Reset on bfcache restore (back button)
  window.addEventListener('pageshow', function () {
    _redirecting = false;
    try {
      sessionStorage.removeItem('chekly_redirecting');
      sessionStorage.removeItem('chekly_about_to_redirect');
      sessionStorage.removeItem('chekly_redirect_timestamp');
    } catch (ex) {}
  });

})();
